import { render, staticRenderFns } from "./root-admin.vue?vue&type=template&id=505f65c9&scoped=true&"
import script from "./root-admin.vue?vue&type=script&lang=js&"
export * from "./root-admin.vue?vue&type=script&lang=js&"
import style0 from "./root-admin.vue?vue&type=style&index=0&id=505f65c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f65c9",
  null
  
)

export default component.exports